export const OS = 'web'
